export function filterByInclusion(string: string | null | undefined, queryString: string): boolean {
  if (!string) {
    return false;
  }

  return string.toLowerCase().includes(queryString.toLowerCase().trim());
}
